import { Plus } from 'lucide-react';

type ClientsHeaderProps = {
  isPending: boolean;
  total: number;
  onCreate: () => void;
  showStats: boolean;
  stats: { total: number; verified: number; pending: number };
};

export function ClientsHeader({ isPending, total, onCreate, showStats, stats }: ClientsHeaderProps) {
  return (
    <>
      <header className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="text-left">
          <p className="m-0 text-[11px] font-semibold tracking-[0.12em] text-[var(--dash-brand)] uppercase">
            Clients
          </p>
          <h1 className="m-0 mt-1 text-2xl font-semibold tracking-tight text-[var(--dash-ink)]">
            Your clients
          </h1>
          <p className="mt-1 mb-0 text-sm text-[var(--dash-muted)]">
            {isPending
              ? 'Loading clients…'
              : `${total} client${total === 1 ? '' : 's'} · manage agency accounts`}
          </p>
        </div>
        <button
          type="button"
          onClick={onCreate}
          className="dash-btn-gradient inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition"
        >
          <Plus className="h-4 w-4" />
          Create Client
        </button>
      </header>

      {showStats ? (
        <div className="camp-fade-up grid grid-cols-3 gap-3">
          {[
            { label: 'Total', value: stats.total },
            { label: 'Verified', value: stats.verified },
            { label: 'Not verified', value: stats.pending },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-[var(--dash-line)] bg-white px-4 py-3 text-left shadow-[0_10px_28px_-22px_rgba(16,38,73,0.35)]"
            >
              <p className="m-0 text-[11px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase">
                {s.label}
              </p>
              <p className="m-0 mt-1 text-xl font-semibold text-[var(--dash-ink)]">{s.value}</p>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
}
